import { EventEmitter, Injectable } from '@angular/core';
import { CanvasService } from './canvas.service';

export enum CanvasInputMode {
    SELECT = 'select',
    GROUP_SELECTED = 'groupSelected',
    UNGROUP_SELECTED = 'ungroupSelected',
    DUPLICATE = 'duplicate',
    MULTISELECT = 'multiselect',
    MOVE_CANVAS = 'moveCanvas',
    COMMENT = 'comment',
    TEXT = 'text',
    TEXT_EDIT = 'textedit',
    CONNECTOR = 'connector',
    PATH_EDIT = 'pathedit',
    TEMPLATE_INSERT = 'insert_template',
    EYE_DROPPER = 'eyeDropper',
    RECTANGLE = 'rect',
    ELLIPSE = 'ellipse',
    POLYGON = 'polygon',
    FREE_DRAW = 'free_draw',
    LINE = 'line',
    ARROW = 'arrow',
    IMAGE = 'image',
    ADD_SVG = 'add_svg',
    INPUT_VALUE = 'inputValue',
    OUTPUT_VALUE = 'outputValue',
    BUTTON = 'button',
    STATUS_INDICATOR = 'status',
    TOGGLE = 'toggleSwitch',
    BAR = 'bar',
    PATH = 'path',
    TRIANGLE = 'triangle',
    CONNECTOR_STRAIGHT = 'connector-straight',
    CONNECTOR_CORNER = 'connector-corner',
    CONNECTOR_DIRECTION = 'connector-direction',
    CONNECTOR_ENDPOINT = 'connector-endpoint',
    CONNECTOR_JUNCTION = 'connector-junction',
    DEFAULT_VALVE = 'default-valve',
    DEFAULT_PUMP = 'default-pump',
    DEFAULT_FAN = 'default-fan',
    DEFAULT_TANK = 'default-tank',
    DEFAULT_SWITCH = 'default-switch',
    GAUGE = 'gauge',
}

@Injectable({ providedIn: 'root' })
export class CanvasInputModeService {
    private _onModeChanged = new EventEmitter<CanvasInputMode>();

    constructor(private canvas: CanvasService) {}

    init() {
        this.bindCanvasEvents();
    }

    private bindCanvasEvents() {
        const canvas = this.canvas.getCanvas();
        canvas.bind('set-select', (win, elem) => this.setMode(CanvasInputMode.SELECT));
    }

    public onModeChanged() {
        return this._onModeChanged;
    }

    private emitModeChange() {
        this._onModeChanged.emit(this.getMode());
    }

    public setMode(tool: CanvasInputMode) {
        const canvas = this.canvas.getCanvas();
        canvas.setMode(tool);
        if (tool === CanvasInputMode.LINE || tool === CanvasInputMode.PATH) {
            const strokeColor = this.canvas.getStrokeColorForBackground();
            if (canvas.curShape) {
                canvas.curShape.stroke = strokeColor;
            }
        }
        this.emitModeChange();
    }

    public getMode(): CanvasInputMode {
        return this.canvas.getCanvas().getMode() as CanvasInputMode;
    }

    public showMoveCursor() {
        return this.canvas.getCanvas().getMode() === CanvasInputMode.MOVE_CANVAS;
    }

    public showDefaultCursor() {
        return (
            this.canvas.getCanvas().getMode() === CanvasInputMode.SELECT ||
            this.canvas.getCanvas().getMode() === CanvasInputMode.MULTISELECT
        );
    }

    public showCommentCursor() {
        return this.canvas.getCanvas().getMode() === CanvasInputMode.COMMENT;
    }

    public showPlusCursor() {
        return !this.showMoveCursor() && !this.showDefaultCursor() && !this.showCommentCursor();
    }
}
